<script setup lang="ts">
import LandingNavbar from '../components/LandingNavbar.vue'
import LandingHero from '../components/LandingHero.vue'
import LandingSimulators from '../components/LandingSimulators.vue'
import LandingCourses from '../components/LandingCourses.vue'
import LandingLiveClasses from '../components/LandingLiveClasses.vue'
import LandingHowItWorks from '../components/LandingHowItWorks.vue'
import LandingFeatures from '../components/LandingFeatures.vue'
import LandingAbout from '../components/LandingAbout.vue'
import LandingPricing from '../components/LandingPricing.vue'
// Seccion de testimonios oculta. El componente `LandingTestimonials.vue` se
// conserva intacto: para republicarlo basta por descomentar el import y la
// etiqueta `<LandingTestimonials />` mas abajo.
// import LandingTestimonials from '../components/LandingTestimonials.vue'
import LandingNews from '../components/LandingNews.vue'
// Seccion de preguntas frecuentes oculta. El componente `LandingFaq.vue` se
// conserva intacto: para republicarla basta por descomentar el import y la
// etiqueta `<LandingFaq />` mas abajo (y restituir el enlace `#faq` del pie).
// import LandingFaq from '../components/LandingFaq.vue'
import LandingContact from '../components/LandingContact.vue'
import LandingCta from '../components/LandingCta.vue'
import LandingFooter from '../components/LandingFooter.vue'
import { provideLandingScroll } from '../composables/useLandingScroll'

/**
 * La seccion de planes/precios esta oculta mientras se define la oferta
 * comercial. El componente `LandingPricing.vue` se conserva intacto: basta con
 * poner este flag en `true` para volver a publicarlo (y restaurar los enlaces
 * a `#precios` en el navbar y el pie).
 */
const showPricing = false

provideLandingScroll()
</script>

<template>
  <div class="landing-ap">
    <LandingNavbar />
    <main>
      <LandingHero />
      <LandingHowItWorks />
      <LandingFeatures />
      <LandingSimulators />
      <LandingAbout />
      <LandingCourses />
      <LandingNews />
      <LandingLiveClasses />
      <LandingPricing v-if="showPricing" />
      <!-- <LandingTestimonials /> -->
      <!-- <LandingFaq /> -->
      <LandingCta />
      <LandingContact />
    </main>
    <LandingFooter />
  </div>
</template>
